import React from 'react';
import {useTranslation} from 'react-i18next';

/**
 * Shared chrome around each onboarding step: eyebrow, title, description,
 * then a content area that renders the step-specific form.
 */
export function StepLayout({stepNumber, totalSteps = 4, title, description, eyebrow, children}) {
    const {t} = useTranslation();
    return (
        <div className={`onboarding-step -step-${stepNumber}`}>
            <header className="onboarding-step-header">
                <p className="onboarding-step-eyebrow">
                    {eyebrow || t('onboarding_wizard.step_eyebrow', {number: stepNumber, total: totalSteps})}
                </p>
                <h1 className="onboarding-step-title">{title}</h1>
                <p className="onboarding-step-description">{description}</p>
            </header>
            <div className="onboarding-step-body">
                {children}
            </div>
        </div>
    );
}

export default StepLayout;
